import React, { useContext, useEffect, useState } from 'react';
import BlockService from '../../../domain/BlockDiagram/BlockService';
import { Pagination, Table } from 'antd';
import { useNavigate } from 'react-router-dom';
import DiagramBlockContext from '@/contexts/DiagramBlockContext';
import DashboardContext from '../../../contexts/DashboardContext';
import HydraulicProfileService from '@/domain/HydraulicProfiler/HydraulicProfilerService';
import { HydraulicProfile } from '@/domain/HydraulicProfiler/HydraulicProfiler';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
  },
];

const hydraulicProfilerService = new HydraulicProfileService();
interface Props {
  locationId: number;
  onClickRow: () => void;
}
export default function HydraulicProfilerCard({
  locationId,
  onClickRow,
}: Props) {
  const navigate = useNavigate();
  const [profilesList, setProfilesList] = useState<HydraulicProfile[]>([]);
  // const [pagination, setPagination] = useState({
  //   page: 1,
  //   pageSize: 10,
  //   totalRecords: 0,
  // });

  async function handleGetProfilesList() {
    const res = await hydraulicProfilerService.getAllProfilesPagination( 1, 100, undefined, locationId);
    setProfilesList(res.data);
  }

  // const onChangePagination = (page: any) => {
  //   setPagination({ ...pagination, page: page });
  // };

  useEffect(() => {
    handleGetProfilesList();
  }, [locationId]);

  return (
    <div className="flex column justify-center items-center">
      <Table
        columns={columns}
        dataSource={profilesList}
        pagination={false}
        onRow={(record: any) => {
          return {
            onClick: () => {
              navigate(`/hydraulic-profiler/${record.profileId}`);
              onClickRow();
            },
            style: { cursor: 'pointer' },
          };
        }}
        style={{ width: '100%' }}
      />
      {/* <Pagination
        style={{ marginTop: '2rem' }}
        onChange={onChangePagination}
        defaultCurrent={1}
        total={pagination.totalRecords}
        showSizeChanger={false}
      /> */}
    </div>
  );
}
